import React, { useEffect } from 'react'
import { Container, Button } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'
import WithFooter from '../Footer'
import Text from './TermsAndConditionsText'

const onAccept = (props) => {
  const { siteContractor, history, contractor } = props

  let contractorView

  if (contractor) {
    contractorView = {
      forename: contractor.forename,
      surname: contractor.surname,
      email: contractor.email,
      employerId: contractor.employerId,
      jobRoleId: contractor.jobRoleId,
      telephoneNumber: contractor.telephoneNumber,
      vehicleRegistration: contractor.vehicleRegistration,
      employerName: contractor.employerName,
      acceptedTCs: true
    }
  } else {
    contractorView = {
      forename: '',
      surname: '',
      email: '',
      employerId: 0,
      jobRoleId: 0,
      telephoneNumber: '',
      vehicleRegistration: '',
      employerName: null,
      acceptedTCs: true
    }
  }
  siteContractor(contractorView)

  history.push('/register/details')
}

const getFooter = props => (
  <Container size="xl">
    <div className="dsib-termsAndConditions__footer">
      <div className="dsib-termsAndConditions__footerInner">
        <Button variant="primary" isFullWidth onClick={() => onAccept(props)}>
          Accept
        </Button>
      </div>
    </div>
  </Container>
)

const TermsAndConditions = (props) => {
  const { setHeader, setSignOutHeader } = props

  useEffect(() => {
    setHeader()
    setSignOutHeader(false)
  }, [setHeader, setSignOutHeader])

  return (
    <WithFooter footer={getFooter(props)}>
      <div className="dsib-termsAndConditions">
        <Container size="xl">
          <div className="dsib-termsAndConditions__titleWrap">
            <h2 className="dsib-termsAndConditions__title">Terms & Conditions</h2>
          </div>
          <div className="dsib-termsAndConditions__content">
            <Text />
          </div>
        </Container>
      </div>
    </WithFooter>
  )
}

TermsAndConditions.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

export default TermsAndConditions
